import React from "react";

const SizedBox = ({ width, height }) => {
  return <div style={{ width, height }} />;
};
export default SizedBox;
